import { Controller } from "@hotwired/stimulus";
import i18n from "../lib/i18n";

const WARNING_THRESHOLD = 100;

export default class extends Controller {
  static targets = ["input", "count"];
  static values = { max: Number };

  connect() {
    this.update();
  }

  update() {
    const length = this.inputTarget.value.length;
    const remaining = this.maxValue - length;
    const isWarning = remaining <= WARNING_THRESHOLD;

    this.countTarget.textContent = isWarning
      ? `${length}/${this.maxValue} — ${i18n.t(
          "js.stimulus_controllers.character_counter.approaching_limit"
        )}`
      : `${length}/${this.maxValue}`;
    this.countTarget.classList.toggle("warning", isWarning);
  }
}
